export class DialogData {
    title: string;
    msg?: string;
    html?: string;
    type: 'html' | 'texto';
    fnSim?: VoidFunction;
    fnNao?: VoidFunction;
    fnFechar?: VoidFunction;
}
